import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const getPresetQuestions = (callback) => {
  return async (dispatch) => {
    dispatch({ type: 'GET_PRESET_QUESTIONS' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.get(`/ads/preset-questions`, {
            params: {
              'request-id': reqId,
            },
            headers: {
              Authorization: `Bearer ${token}`,
              // 'x-api-version': 'v2',
            },
          });
          if (response.status === 200) {
            await dispatch({
              type: 'GET_PRESET_QUESTIONS_DONE',
              payload: {
                questions: response?.data?.questionsWithWordLimit,
              },
            });
            if (typeof callback === 'function') {
              callback(response?.data?.questionsWithWordLimit);
            }
          } else {
            dispatch({
              type: 'GET_PRESET_QUESTIONS_FAILED',
              payload: `Failed to fetch preset questions`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'GET_PRESET_QUESTIONS_FAILED',
            payload: `Failed to fetch preset questions`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'GET_PRESET_QUESTIONS_FAILED',
        payload: `Failed to fetch preset questions`,
      });
    }
  };
};

export default getPresetQuestions;
